import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.warning.light,
      padding: theme.spacing(1.5, 2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      columnGap: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadiusSmall,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(1),
      color: COLORS.gray.black,
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.warning.active,
    },
  }),
  { name: 'AuthErrorMessage' }
);
